/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const collectRouter = {
  path: '/collect',
  component: Layout,
  name: 'collect',
  redirect: '/collect',
  hidden: true,
  meta: {
    title: '个人中心'
  },
  children: [
    {
      path: '/collect',
      component: () => import('@/views/collect/index'),
      name: 'collect',
      meta: { title: '我的收藏', affix: true, power: true }
    }
  ]
}

export default collectRouter